import { SVGProps } from 'react'

export const CameraCirculeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_19145_39285)">
      <rect x="2" y="1" width="40" height="40" rx="20" fill="white" />
      <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#EAECF0" />
      <rect width="20" height="20" transform="translate(12 11)" fill="white" />
      <path
        d="M13.667 17.981C13.667 17.689 13.667 17.5431 13.6792 17.4201C13.7967 16.2343 14.7347 15.2963 15.9205 15.1788C16.0434 15.1666 16.1973 15.1666 16.505 15.1666C16.6235 15.1666 16.6828 15.1666 16.7331 15.1636C17.3758 15.1247 17.9386 14.719 18.1788 14.1216C18.1976 14.0748 18.2152 14.0221 18.2503 13.9166C18.2855 13.8111 18.3031 13.7584 18.3219 13.7116C18.562 13.1142 19.1248 12.7086 19.7675 12.6697C19.8178 12.6666 19.8734 12.6666 19.9846 12.6666H24.016C24.1272 12.6666 24.1828 12.6666 24.2331 12.6697C24.8758 12.7086 25.4386 13.1142 25.6788 13.7116C25.6976 13.7584 25.7152 13.8111 25.7503 13.9166C25.7855 14.0221 25.8031 14.0748 25.8219 14.1216C26.062 14.719 26.6248 15.1247 27.2675 15.1636C27.3178 15.1666 27.3771 15.1666 27.4957 15.1666C27.8034 15.1666 27.9572 15.1666 28.0802 15.1788C29.2659 15.2963 30.204 16.2343 30.3215 17.4201C30.3337 17.5431 30.3337 17.689 30.3337 17.981V24.5C30.3337 25.9001 30.3337 26.6002 30.0612 27.1349C29.8215 27.6053 29.439 27.9878 28.9686 28.2275C28.4339 28.5 27.7338 28.5 26.3337 28.5H17.667C16.2669 28.5 15.5668 28.5 15.032 28.2275C14.5616 27.9878 14.1792 27.6053 13.9395 27.1349C13.667 26.6002 13.667 25.9001 13.667 24.5V17.981Z"
        stroke="#475467"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.0003 24.75C23.8413 24.75 25.3337 23.2576 25.3337 21.4166C25.3337 19.5757 23.8413 18.0833 22.0003 18.0833C20.1594 18.0833 18.667 19.5757 18.667 21.4166C18.667 23.2576 20.1594 24.75 22.0003 24.75Z"
        stroke="#475467"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_19145_39285"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_19145_39285"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_19145_39285"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
